export default "__VITE_ASSET__Boi1pc4q__"